import React from 'react';

const HotmessBanner = () => {
  const styles = {
    banner: {
      backgroundColor: '#000000',
      color: '#ffffff',
      display: 'block',
      padding: '0 5vw',
      paddingTop: 'clamp(20px, 10vh, 80px)',
      paddingBottom: 'clamp(20px, 10vh, 80px)',
      fontFamily: 'Arial, Helvetica, sans-serif',
      width: '100%',
      margin: '0',
      boxSizing: 'border-box',
      overflowX: 'hidden',
    },
    leftSection: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 'clamp(15px, 3vw, 4vw)',
      flex: '0 0 auto',
    },
    rawText: {
      color: '#e60000',
      fontSize: 'clamp(40px, 9vw, 90px)',
      fontWeight: '900',
      transform: 'rotate(-90deg)',
      transformOrigin: 'center',
      whiteSpace: 'nowrap',
      lineHeight: '1',
      letterSpacing: 'clamp(2px, 0.3vw, 4px)',
    },
    rightSection: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: '70vw',
      minWidth: '0',
    },
    hotmess: {
      color: '#e60000',
      fontSize: 'clamp(32px, 6vw, 64px)',
      fontWeight: '900',
      lineHeight: '1.1',
      marginBottom: 'clamp(6px, 1vw, 8px)',
      wordBreak: 'keep-all',
    },
    subtitle: {
      fontSize: 'clamp(12px, 2vw, 20px)',
      fontWeight: '500',
      marginBottom: 'clamp(8px, 1.2vw, 12px)',
      lineHeight: '1.2',
    },
    title: {
      fontSize: 'clamp(20px, 3vw, 32px)',
      fontWeight: '900',
      marginBottom: 'clamp(12px, 1.5vw, 16px)',
      lineHeight: '1.1',
    },
    footer: {
      fontSize: 'clamp(10px, 1.5vw, 16px)',
      fontWeight: '500',
      textTransform: 'uppercase',
      lineHeight: '1.3',
    },
    divider: {
      margin: '0 clamp(4px, 0.6vw, 6px)',
      color: '#ffffff',
    },

    // Story block
    storyBlock: {
      display: 'flex',
      flexWrap: 'nowrap',
      width: '100%',
      margin: '0',
      boxSizing: 'border-box',
      overflowX: 'hidden',
    },
    storyLeftWrapper: {
      display: 'flex',
      flexDirection: 'column',
      flex: '1',
    },
    storyLeft: {
      backgroundColor: '#ffffff',
      color: '#e60000',
      fontWeight: '900',
      fontSize: 'clamp(20px, 4vw, 34px)',
      lineHeight: '1.2',
      textTransform: 'uppercase',
      padding: '40px 20px',
      flex: '1',
      textAlign: 'center',
    },
    storyRedFooter: {
      backgroundColor: '#e60000',
      color: '#000000',
      fontWeight: '900',
      fontSize: 'clamp(14px, 2.5vw, 22px)',
      textTransform: 'uppercase',
      padding: '20px',
      textAlign: 'center',
    },
    storyRight: {
      backgroundColor: '#000000',
      color: '#ffffff',
      flex: '1',
      padding: '40px 20px',
      fontSize: 'clamp(10px, 2vw, 18px)',
      lineHeight: '1.6',
    },
    storyRightStrong: {
      fontWeight: '700',
    },

    // Final Clickable Section
    ctaSection: {
      backgroundColor: '#f7f7f5',

      padding: '20px clamp(20px, 5vw, 40px)',
      boxSizing: 'border-box',
      fontFamily: 'Arial, Helvetica, sans-serif',
      display: 'flex',
      flexDirection: 'column',
      cursor: 'pointer',
      textDecoration: 'none',
      alignItems: 'center',
      width: '100%',
      margin: '0',
      overflowX: 'hidden',
    },
    ctaTop: {
      color: '#e60000',
      fontSize: 'clamp(18px, 4vw, 32px)',
      fontWeight: '900',
      textTransform: 'uppercase',
      marginBottom: '10px',
    },
    ctaBottom: {
      display: 'flex',
      flexWrap: 'wrap',
      fontSize: 'clamp(12px, 2vw, 16px)',
      color: '#000',
      fontWeight: '500',
      justifyContent: 'space-between',
    },
    italic: {
      fontStyle: 'italic',
    },
    label: {
      fontWeight: '700',
    },
  };

  const handleCTAClick = () => {
    window.open('https://www.beatport.com/label/raw-convict-records/129765', '_blank'); // 🔁 Replace with your real link
  };

  return (
    <>
      {/* Main Banner */}
      <div style={styles.banner}>
        <div style={{ display: 'flex' }}>
          <div style={styles.leftSection}>
            <div style={styles.rawText}>RAW</div>
          </div>
          <div style={styles.rightSection}>
            <div style={styles.hotmess}>HOTMESS</div>
            <div style={styles.subtitle}>Stephen Nichols & Nick Denton Mix</div>
            <div style={styles.title}>THE 4TH REPUTATION</div>
            <div style={styles.footer}>
              RAW CONVICT RECORDS
              <span style={styles.divider}>|</span>
              DROPS NEXT WEEK
            </div>
          </div>
        </div>
      </div>

      {/* Story Block */}
      <div style={styles.storyBlock}>
        <div style={styles.storyLeftWrapper}>
          <div style={styles.storyLeft}>
            HOTMESS<br />
            BEGAN<br />
            AS A BRAND.<br />
            THEN IT<br />
            BECAME<br />
            AN ANTHEM.
          </div>
          <div style={styles.storyRedFooter}>
            NOT JUST MUSIC.<br />
            A REPUTATION
          </div>
        </div>
        <div style={styles.storyRight}>
          HOTMESS London wasn’t just launched — it was soundtracked.
          <br /><br />
          Paul King and Stewart Who created the debut track <span style={styles.storyRightStrong}>Hotmess</span> as the raw, unapologetic heartbeat of the brand.
          <br /><br />
          Since then, three reputations of the track have wrecked dancefloors.
          <br /><br />
          Now comes the 4th reputation — engineered by <span style={styles.storyRightStrong}>Stephen Nichols</span> & <span style={styles.storyRightStrong}>Nick Denton</span>.
          <br /><br />
          This isn’t a remix. It’s part of the origin story.<br />
          A sound stitched into the fabric of HOTMESS London.
        </div>
      </div>

      {/* Final Clickable Section */}
      <div style={styles.ctaSection} onClick={handleCTAClick}>
        <div style={styles.ctaTop}>LISTEN PRE-SAVE · JOIN</div>
        <div style={styles.ctaBottom}>
          <div>
            DEBUT TRACK: <span style={styles.italic}>HOTMESS</span> — Paul King x Stewart Who
          </div>
          <div style={styles.label}>
            LABEL: RAW CONVICT RECORDS
          </div>
        </div>
      </div>
    </>
  );
};

export default HotmessBanner;
